export default class UpdateDualloUserModel {
  organizationId = null;
  id = null;
  acceptedTermsOfService = false;
  termsAcceptedOn = false;
  eTag = null;

  constructor(organizationId, id, acceptedTermsOfService, termsAcceptedOn, eTag) {
    this.organizationId = organizationId;
    this.id = id;
    this.acceptedTermsOfService = acceptedTermsOfService;
    this.termsAcceptedOn = termsAcceptedOn;
    this.eTag = eTag;
  }
}